
const AISearchIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Search"
      className="f0hiXs2f azx1cEWI"
      viewBox="0 0 24 24"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fill="#fff"
          d="M16.6 18.778l-3.554-3.56a2.165 2.165 0 00-.382-.312l-.889-.614a6.236 6.236 0 00.041-7.78 6.215 6.215 0 00-7.57-1.752 6.232 6.232 0 106.596 10.485l.666.89c.08.114.169.221.267.32l3.555 3.56a.444.444 0 00.631 0l.622-.623a.445.445 0 00.018-.614zm-9.642-3.952a4.447 4.447 0 01-4.443-4.45c0-2.457 1.99-4.45 4.443-4.45a4.447 4.447 0 014.444 4.45c0 1.18-.468 2.313-1.302 3.147a4.44 4.44 0 01-3.142 1.303zM19.5 7.143c.03 0 .054.022.057.052.49 3.463 1.101 3.873 4.393 4.387.028.005.05.031.05.06 0 .03-.02.057-.05.06-3.293.515-3.904.926-4.393 4.388-.004.03-.029.053-.057.053a.059.059 0 01-.057-.053c-.49-3.463-1.1-3.873-4.393-4.387a.062.062 0 01-.05-.06c0-.03.021-.057.05-.06 3.293-.515 3.904-.926 4.393-4.388.005-.03.03-.052.057-.052zM15.714 8c-.018 0-.034-.015-.036-.035-.305-2.309-.878-2.582-2.933-2.925a.04.04 0 01-.031-.04c0-.02.013-.038.031-.04 2.056-.343 2.628-.617 2.933-2.925.003-.02.018-.035.036-.035.017 0 .033.015.036.035.305 2.309.877 2.582 2.933 2.925a.04.04 0 01.03.04c0 .02-.012.038-.03.04-2.056.343-2.628.617-2.933 2.925-.003.02-.019.035-.036.035z"
        ></path>
      </svg>
    </svg>
  );
}

export default AISearchIcon;